"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
const ether_utils_1 = require("../utils/ether-utils");
class OnchainPoolToken {
    constructor() {
        this.cache = {};
        // Cache that can't be erased
        this.lockedCache = {};
    }
    cleanCache() {
        this.cache = {};
    }
    getPoolToken() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.cache.poolToken)
                this.cache.poolToken = this.initializePoolToken();
            return this.cache.poolToken;
        });
    }
    getToken() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.cache.token)
                this.cache.token = this.initializeToken();
            return this.cache.token;
        });
    }
    getTokenAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getToken())._address;
        });
    }
    getDecimals() {
        return __awaiter(this, void 0, void 0, function* () {
            const offchainPoolToken = yield this.getOffchainPoolToken();
            return yield offchainPoolToken.getDecimals();
        });
    }
    // Utilities
    normalize(amount) {
        return __awaiter(this, void 0, void 0, function* () {
            return amount / Math.pow(10, yield this.getDecimals());
        });
    }
    toBigNumber(amount) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(0, utils_1.isValidNumber)(amount))
                return null;
            return (0, ether_utils_1.decimalToBalance)(amount, yield this.getDecimals());
        });
    }
    toNumber(amount) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!amount)
                return null;
            return parseFloat(amount.toString()) / Math.pow(10, yield this.getDecimals());
        });
    }
    toTokens(amount) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(0, utils_1.isValidNumber)(amount))
                return null;
            const exchangeRate = yield this.getLockedExchangeRate();
            return (0, ether_utils_1.decimalToBalance)(amount / exchangeRate, yield this.getDecimals());
        });
    }
    fromTokens(amount) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!amount)
                return null;
            const exchangeRate = yield this.getLockedExchangeRate();
            return parseFloat(amount.toString()) * exchangeRate / Math.pow(10, yield this.getDecimals());
        });
    }
    // Total balance
    initializeTotalBalance() {
        return __awaiter(this, void 0, void 0, function* () {
            const poolToken = yield this.getPoolToken();
            const amount = yield poolToken.methods.totalBalance().call();
            return this.normalize(amount);
        });
    }
    getTotalBalance() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.cache.totalBalance)
                this.cache.totalBalance = this.initializeTotalBalance();
            return this.cache.totalBalance;
        });
    }
    getTotalBalanceUSD() {
        return __awaiter(this, void 0, void 0, function* () {
            const totalBalance = yield this.getTotalBalance();
            const offchainPoolToken = yield this.getOffchainPoolToken();
            const tokenPrice = yield offchainPoolToken.getTokenPriceFast();
            return totalBalance * tokenPrice;
        });
    }
    // Exchange rate
    initializeExchangeRate() {
        return __awaiter(this, void 0, void 0, function* () {
            const poolToken = yield this.getPoolToken();
            return (yield poolToken.methods.exchangeRate().call()) / 1e18;
        });
    }
    getExchangeRate() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.cache.exchangeRate)
                this.cache.exchangeRate = this.initializeExchangeRate();
            return this.cache.exchangeRate;
        });
    }
    getLockedExchangeRate() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.lockedCache.exchangeRate)
                this.lockedCache.exchangeRate = this.getExchangeRate();
            return this.lockedCache.exchangeRate;
        });
    }
}
exports.default = OnchainPoolToken;
